const { onlyAlphaNumeric, SPACE } = require('../helpers');

exports.zipCodeNormalize = (zipCode) => {
  if (!zipCode) {
    return zipCode;
  }
  const zip = onlyAlphaNumeric(zipCode);
  if (zipCode.length <= 2) {
    return zip;
  }
  return `${zip.slice(0, 2).toUpperCase()} ${zip.slice(2, 5)}`;
};

exports.countryDefinition = {
  country: 'Bermuda',
  code: 'BM',
  schema: {
    company: { label: 'Company' },
    address: { label: 'Street Address' },
    address2: { label: 'Street Address 2' },
    city: { label: 'Town', width: 0.5 },
    zipCode: {
      label: 'Postal Code',
      width: 0.5,
      normalize: exports.zipCodeNormalize
    }
  },
  viewFormat: [
    ['company'],
    ['address'],
    ['address2'],
    ['zipCode', SPACE, 'city']
  ],
  formFormat: [['company'], ['address'], ['address2'], ['zipCode', 'city']],
  requiredFormFields: [
    { field: 'address' },
    { field: 'city' },
    {
      field: 'zipCode',
      validationRegex: new RegExp(/^[A-Z]{2}[0-9]{2}$/),
      error: 'Must be 2 characters and 2 numbers, FL07'
    }
  ]
};
